import { useSetToast } from "@app/components/Toast";
import { Button } from "@design-system/Inputs/Button";
import { FlexRow } from "@design-system/Layout/Flex";
import { Text } from "@design-system/Typography/Text";
import { ResponseStatus } from "@generated/client/graphql";
import { useAtom } from "jotai";
import { useState } from "react";
import { isAddCustomItemModalOpenAtom } from "../../ctx";
import { useCreateCustomKnowledgeBaseItem } from "../../data";
import { useKnowledgeBasePageTranslations } from "../../i18n";
import { AddCustomItemModal } from "../AddCustomItemModal";

export const AddItemButton = () => {
    const { t, keys } = useKnowledgeBasePageTranslations();
    const { setToastSuccess, setToastError } = useSetToast();
    const { createCustomItem } = useCreateCustomKnowledgeBaseItem();

    const [open, setOpen] = useAtom(isAddCustomItemModalOpenAtom);
    const [description, setDescription] = useState<string | undefined>(
        undefined,
    );
    const [value, setValue] = useState<string | undefined>(undefined);

    const handleClick = () => {
        setOpen(true);
    };

    const handleOpenChange = (open: boolean) => {
        setOpen(open);
    };

    const handleSave = (
        description: string | undefined,
        value: string | undefined,
    ) => {
        if (!description) {
            setToastError(t(keys.create_custom_item_error));
            return;
        }
        createCustomItem(
            { description, value },
            {
                onSettled: (data) => {
                    if (
                        data?.createCustomItem?.status ===
                        ResponseStatus.Success
                    ) {
                        setOpen(false);
                        setDescription(undefined);
                        setValue(undefined);
                        return setToastSuccess(
                            t(keys.create_custom_item_success),
                        );
                    }
                    return setToastError(t(keys.create_custom_item_error));
                },
            },
        );
    };

    return (
        <>
            <Button variant="flatPrimary" size="sm" onClick={handleClick}>
                <FlexRow gap="2" alignItems="center">
                    <Text variant="body-sm-bold" color="white">
                        {t(keys.add_custom_item)}
                    </Text>
                    <Button.Icon name="plus" size="sm" color="white" />
                </FlexRow>
            </Button>
            <AddCustomItemModal
                open={open}
                onOpenChange={handleOpenChange}
                onSave={handleSave}
                description={description}
                onDescriptionChange={setDescription}
                value={value}
                onValueChange={setValue}
            />
        </>
    );
};
